import moment from "moment";
import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import "react-quill/dist/quill.snow.css";
import DatePicker from "react-datepicker";
import { numberFormat, showMessage } from "../../Utils/comman"; // import styles for the editor

function CreateInvoice(props) {
  const dispatch = useDispatch();
  const [orderId, setOrderId] = useState(0);
  const [formData, setFormData] = useState({
    orderId: orderId,
    invoiceDate: new Date(),
  });
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  const [piData, setPiData] = useState([]);
  const [grandTotals, setGrandTotals] = useState({
    total_qty: 0,
    gross_amount: 0,
    trade_discount: 0,
    qty_discount: 0,
    cash_discount: 0,
    special_discount: 0,
    final_amount: 0,
    insurance_per: 0,
    insurance_amount: 0,
    freight_amount: 0,
    cgst: 0,
    sgst: 0,
    igst: 0,
    tcs_per: 0,
    tcs_amount: 0,
    round_off: 0,
    grand_total: 0,
  });
  const [orderProducts, setOrderProducts] = useState([]);

  useEffect(() => {
    setOrderId(
      props?.rowData?.orderdata && props?.rowData?.orderdata.id
        ? props?.rowData?.orderdata.id
        : props?.rowData?.id
    );
  }, []);

  useEffect(() => {
    if (orderId > 0) {
      getPiData();
    }
  }, [orderId]);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const getPiData = () => {
    utils
      // .callAPI("get", `/sales/getInvoiceList?id=${orderId}`)
      .callAPI("get", `/sales/getCreateInvoiceData?id=${orderId}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          let orderStatus = parseInt(res?.order_status);
          if (isNaN(orderStatus) && res?.order_data) {
            orderStatus = parseInt(res?.order_data?.order_status);
          }

          const products = [...res?.Proforma_invoice_products];
          products.map((product) => {
            product.size = (product.size * 1).toFixed(2);
            product.total_qty = (
              product.total_qty ? parseFloat(product.total_qty) : 0
            ).toFixed(2);
          });

          setFormData({ ...formData, orderId: orderId });
          setOrderProducts(products);
          setGrandTotals(res?.grand_totals || {});
          setPiData(res);
        } else {
          setPiData([]);
        }
      })
      .catch((err) => {
        setPiData([]);
      });
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleSubmitButton = () => {
    if (!formData.invoiceDate) {
      showMessage("Please Select Invoice date", "error");
      return false;
    }
    const formDataPost = new FormData();
    formDataPost.append("order_id", formData.orderId);
    formDataPost.append("invoice_data", JSON.stringify(piData));
    formDataPost.append(
      "date",
      moment(formData.invoiceDate).format("YYYY-MM-DD")
    );

    utils
      .callAPI("post", "/sales/create_main_invoice", formDataPost)
      .then((res) => {
        if (typeof res !== "undefined") {
          const propdata = { mode: "list" };
          props.onChange(propdata);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          <h4>Create Invoice</h4>
          <div className="card-header-action">
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <div className={"pi-invoice"}>
            <RB.Row className={"border"}>
              <RB.Col md={12} className={"py-2 text-center"}>
                <h6 className={"mb-0"}>TAX INVOICE</h6>
                <small>Issued under GST Invoice Rules</small>
              </RB.Col>
            </RB.Row>

            <RB.Row className={"border border-top-0"}>
              <RB.Col md={4} className={"border-end py-2"}>
                <h6>
                  <strong>Supplier - Seller:</strong>
                </h6>
                <p className={"mb-0"}>
                  <strong>{piData.registered_office?.company_name}</strong>
                </p>
                <p className={"mb-0"}>
                  {piData.registered_office?.address}
                  <br />
                  {piData.registered_office?.city} -{" "}
                  {piData.registered_office?.pincode}
                </p>
                <p className={"mb-0"}>
                  <strong>State:</strong> {piData.registered_office?.state}
                </p>
                <RB.Row>
                  <RB.Col md={6}>
                    <strong>GSTIN:</strong> {piData.registered_office?.gstno}
                  </RB.Col>
                  {/*<RB.Col md={6}>
                    <strong>PAN:</strong> AABCS4338M
                  </RB.Col>*/}
                </RB.Row>

                {/*<RB.Row>
                  <RB.Col md={6}>
                    <strong>CIN:</strong> U26109TN1997PL037875
                  </RB.Col>
                  <RB.Col md={6}>
                    <strong>TAN:</strong> CHES05530A
                  </RB.Col>
                </RB.Row>*/}
              </RB.Col>
              <RB.Col md={4} className={"border-end py-2"}>
                <h6>
                  <strong>Recipient - Customer :</strong>
                </h6>
                <>
                  <p className={"mb-0"}>
                    <strong>{piData?.bill_to_data?.company_name}</strong>
                  </p>
                  <p className={"mb-0"}>
                    {piData?.bill_to_data?.company_address},<br />
                    {piData?.bill_to_data?.district},<br />
                    {piData?.bill_to_data?.city} -{" "}
                    {piData?.bill_to_data?.pincode},<br />
                    {/*Ph. : BILL TO PHONE<br/>*/}
                  </p>
                  <p className={"mb-0"}>
                    <strong>State:</strong> {piData?.bill_to_data?.state}
                  </p>
                  <p className={"mb-0"}>
                    <strong>GSTIN:</strong> {piData?.bill_to_data?.gst_no}
                  </p>
                </>
              </RB.Col>
              <RB.Col md={4} className={"border1 py-2"}>
                <p className={"mb-0"}>
                  <strong>Invoice No.: </strong> AUTO GENERATE
                </p>
                <RB.Row className={"align-items-center"}>
                  <RB.Col md={"auto"}>
                    <strong>Date: </strong>
                  </RB.Col>
                  <RB.Col>
                    <DatePicker
                      selected={formData.invoiceDate}
                      onChange={(date) =>
                        setFormData({ ...formData, invoiceDate: date })
                      }
                      dateFormat="dd-MM-yyyy"
                      className="form-control form-control-sm"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  </RB.Col>
                </RB.Row>
                <p className={"mb-0"}>
                  <strong>Proforma Invoice No.: </strong> {piData?.invoice_no}
                </p>
                <p className={"mb-0"}>
                  <strong>Proforma Invoice Date: </strong>{" "}
                  {moment(piData?.invoice_date).format("DD-MM-YYYY")}
                </p>
                <p className={"mb-0"}>
                  <strong>Sales Order No.: </strong>{" "}
                  {piData?.order_data?.order_id}
                </p>
                <p className={"mb-0"}>
                  <strong>Sales Order Date: </strong>{" "}
                  {moment(piData?.order_date).format("DD-MM-YYYY")}
                </p>
                <p className={"mb-0"}>
                  <strong>Ref.: </strong> {piData?.emp_ref_no}
                </p>
              </RB.Col>
            </RB.Row>

            <RB.Row className={"border border-top-0"}>
              <RB.Col md={4} className={"border-end py-2"}>
                <h6>
                  <strong>Destination Center:</strong>
                </h6>
                <>
                  <p className={"mb-0"}>
                    <strong>{piData?.location_data?.name}</strong>
                  </p>
                  <p className={"mb-0"}>
                    {piData?.location_data?.address},<br />
                    {/*{piData?.location_data?.district},<br/>*/}
                    {piData?.location_data?.city} -{" "}
                    {piData.location_data?.pincode},<br />
                    {piData.location_data?.state}
                  </p>
                </>
              </RB.Col>
              <RB.Col md={4} className={"border-end py-2"}>
                <h6>
                  <strong>Ship - To :</strong>
                </h6>
                <>
                  <p className={"mb-0"}>
                    <strong>{piData?.ship_to_data?.company_name}</strong>
                  </p>
                  <p className={"mb-0"}>
                    {piData?.ship_to_data?.company_address},<br />
                    {piData?.ship_to_data?.city},<br />
                    {piData?.ship_to_data?.state} -{" "}
                    {piData?.ship_to_data?.pincode}
                  </p>
                </>
              </RB.Col>
              <RB.Col md={4} className={"border1 py-2"}>
                <h6>
                  <strong>Transport Details:</strong>
                </h6>
                <p className={"mb-0"}>
                  <strong>Transporter:</strong> {piData?.transporter_name}
                </p>
                <p className={"mb-0"}>
                  <strong>Destination:</strong> {piData?.destination}
                </p>
                <p className={"mb-0"}>
                  <strong>Vehicle No.:</strong> {piData?.motor_vehicle_no}
                </p>
                <p className={"mb-0"}>
                  <strong>Driver Name:</strong> {piData?.driver_name}
                </p>
                <p className={"mb-0"}>
                  <strong>Driver Mobile No.:</strong> {piData?.driver_mobile_no}
                </p>
                <p className={"mb-0"}>
                  <strong>Bill of Lading/LR-RR No.:</strong>{" "}
                  {piData?.bill_of_landing_lr_rr_no}
                </p>
              </RB.Col>
            </RB.Row>

            <RB.Row className={"border border-bottom-0"}>
              <h5 className="mt-3">Products</h5>

              <div className={"table-responsive p-0 border"}>
                <RB.Table
                  bordered
                  hover
                  striped
                  className="border mb-0 table-sm table-invoice-products"
                >
                  <thead>
                    <tr>
                      <th rowSpan={2}>S.No</th>
                      <th rowSpan={2}>Description of Goods</th>
                      <th className={"text-center"} rowSpan={2}>
                        UOM
                      </th>
                      <th className={"text-center"} rowSpan={2}>
                        HSN
                      </th>
                      <th className={"text-center"}>CGST</th>
                      <th className={"text-center"}>SGST</th>
                      <th className={"text-center"}>IGST</th>
                      <th className={"text-center"} rowSpan={2}>
                        Rate / UOM
                      </th>
                      <th colSpan={3} className={"text-center"}>
                        Quantity
                      </th>
                      <th className={"text-center"} rowSpan={2}>
                        Gross Value
                      </th>
                      <th className={"text-center"} colSpan={4}>
                        Discounts
                      </th>
                      <th className={"text-center"} rowSpan={2}>
                        Net Value
                      </th>
                    </tr>
                    <tr>
                      <th className={"text-center"}>%</th>
                      <th className={"text-center"}>%</th>
                      <th className={"text-center"}>%</th>
                      <th className={"text-center"}>In UOM</th>
                      <th className={"text-center"}>Pack Size</th>
                      <th className={"text-center"}>Total Qty(Kg)</th>
                      <th className={"text-center"}>Trade(%)</th>
                      <th className={"text-center"}>Quantity (%)</th>
                      <th className={"text-center"}>Cash (%)</th>
                      <th className={"text-center"}>Special (%)</th>
                    </tr>
                  </thead>

                  <tbody>
                    {orderProducts.length &&
                      orderProducts.map((product, index) => (
                        <tr key={index}>
                          <td className={"text-center"}>{index + 1}</td>
                          <td>{product.product_name}</td>
                          <td className={"text-center"}>
                            {(product.mou || "").toUpperCase()}
                          </td>
                          <td className={"text-center"}>
                            {product.hsn_code || ""}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product?.gst?.cgst?.per || 0).toFixed(
                              2
                            )}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product?.gst?.sgst?.per || 0).toFixed(
                              2
                            )}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(product?.gst?.igst?.per || 0).toFixed(
                              2
                            )}
                          </td>
                          <td className={"text-end"}>
                            {numberFormat(product.rate)}
                          </td>
                          <td className={"text-end"}>{product?.actual_qty}</td>
                          <td className={"text-end"}>
                            {parseFloat(product?.size).toFixed(2)}
                          </td>
                          <td className={"text-end"}>{product.total_qty}</td>
                          <td className={"text-end"}>
                            {numberFormat(product?.gross_amount)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(
                              product?.discounts?.trade?.per || 0
                            ).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(
                              product?.discounts?.qty?.per || 0
                            ).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(
                              product?.discounts?.cash?.per || 0
                            ).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {parseFloat(
                              product?.discounts?.special?.per || 0
                            ).toFixed(2)}
                          </td>
                          <td className={"text-end"}>
                            {numberFormat(product?.row_amount)}
                          </td>
                        </tr>
                      ))}
                  </tbody>

                  <tfoot>
                    <tr>
                      <th colSpan={9}></th>
                      <th className={"text-end"}>Total</th>
                      <th className={"text-end"}>
                        {parseFloat(grandTotals?.total_qty).toFixed(2)}
                      </th>
                      <th className={"text-end"}>
                        {numberFormat(grandTotals?.gross_amount)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(grandTotals?.trade_discount)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(grandTotals?.qty_discount)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(grandTotals?.cash_discount)}
                      </th>
                      <th className={"text-end"}>
                        -{numberFormat(grandTotals?.special_discount)}
                      </th>
                      <th className={"text-end"}>
                        {numberFormat(grandTotals?.final_amount)}
                      </th>
                    </tr>
                  </tfoot>
                </RB.Table>
              </div>
            </RB.Row>

            <RB.Row>
              <RB.Col
                md={8}
                className={"border border-top-0 order-sm-1 order-md-1 order-2"}
              >
                <RB.Row className={"border-bottom py-1"}>
                  <RB.Col>
                    <strong>Total in Words: {piData?.grand_total_word}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom py-1"}>
                  <RB.Col className={"small"}>
                    {piData?.terms_condition?.line1}
                    {/* Certified that the particular given above are true and
                    correct and the amounts indicated represent the prices
                    actually charged and that there is no flow of additional
                    consideration directly or indirectly from the buyer */}
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"border-bottom py-2"}>
                  <RB.Col>
                    <p
                      className="mb-0"
                      dangerouslySetInnerHTML={{
                        __html: piData?.terms_condition?.line2,
                      }}
                    ></p>
                    {/* <strong>
                      Whether GST Payable Under Reverse Charge Mechanism: NO
                    </strong> */}
                    {/* <ol className={"small mb-0"}>
                      <li>
                        Customer are requested to report any shortages, etc. in
                        the material received with in 15 days of material.
                      </li>
                      <li>
                        Interest @24% p.a. will be charged if the payment is not
                        received on or before the due date
                      </li>
                      <li>
                        Increase in the pride due to government control or
                        actions or any changes in the taxes, duties, impositions
                        by central, state or local authorities, shall be to
                        consumer's account.
                      </li>
                      <li>
                        Any disputes or differences relating to the order or in
                        connection with the terms conditions of sale, will be
                        subject to the jurisdiction of Courts only
                      </li>
                    </ol> */}
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"py-1"}>
                  <RB.Col>
                    <strong>Terms and Conditions </strong>
                    <p className={"mb-1"} style={{ lineHeight: "normal" }}>
                      <small>
                        {piData?.terms_condition?.line3}
                        {/* "we hereby certify that our registration Certificate
                        under the Goods and Service Tax, 2017 is in force on the
                        date on which the sale of the goods specified in this
                        tax invoice is executed and that the transaction of sale
                        covered by this tax invoice has been effected by us and
                        it shall be accounted for the turnover of the sale while
                        filling of return and the due tax, if any payable on the
                        sales has been paid or shall be paid"{" "} */}
                      </small>
                    </p>
                    {/* <p className={"mb-1"} style={{ lineHeight: "normal" }}>
                      <small>
                        The Buyer is prohibited from doing business, either
                        directly or indirectly, with any and all
                        countries/region that the subject to embargo & sanctions
                        imposed by United Nations, European Union and/or the
                        United State of America (collectively the "Sanctioned
                        Countries"). The seller confirms to have discharged its
                        obligation to inform the buyer that engaging into
                        business transaction with Sanctioned Countries is
                        prohibited, and buyer confirms to be aware of the
                        aforementioned Obligations and agrees to support the
                        seller in the compliance with related regulations as
                        such.{" "}
                      </small>
                    </p> */}

                    {piData?.delivery_terms
                      ? piData?.delivery_terms
                          .split("\n")
                          .map(function (item, idx) {
                            return (
                              <p
                                className={"small mb-1"}
                                style={{ lineHeight: "normal" }}
                                key={idx}
                              >
                                {item}
                              </p>
                            );
                          })
                      : " "}
                  </RB.Col>
                </RB.Row>
              </RB.Col>
              <RB.Col md={4} className={"border order-md-2 order-sm-2 order-1"}>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    Net Amount
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(grandTotals?.final_amount)}</strong>
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    Insurance{" "}
                    {grandTotals?.insurance_per > 0
                      ? `(${grandTotals?.insurance_per}%)`
                      : ""}
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>
                      {numberFormat(
                        grandTotals?.insurance_amount > 0
                          ? grandTotals?.insurance_amount
                          : 0
                      )}
                    </strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    Freight Amount (₹)
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>
                      {numberFormat(
                        grandTotals?.freight_amount > 0
                          ? grandTotals?.freight_amount
                          : 0
                      )}
                    </strong>
                  </RB.Col>
                </RB.Row>

                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    CGST
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(grandTotals?.cgst)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    SGST
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(grandTotals?.sgst)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    IGST
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(grandTotals?.igst)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    TCS{" "}
                    {grandTotals?.tcs_per ? `(${grandTotals?.tcs_per} %)` : ""}
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(grandTotals?.tcs_amount)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    Round Off
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(grandTotals?.round_off)}</strong>
                  </RB.Col>
                </RB.Row>
                <RB.Row className={"border-bottom align-items-center bg-light"}>
                  <RB.Col xs={5} sm={5} md={5} className={"border-end py-1"}>
                    <strong>Invoice Total</strong>
                  </RB.Col>
                  <RB.Col xs={7} sm={7} md={7} className={"text-end py-1"}>
                    <strong>{numberFormat(grandTotals?.grand_total)}</strong>
                  </RB.Col>
                </RB.Row>
              </RB.Col>
            </RB.Row>

            <RB.Row className={"mt-3"}>
              <RB.Col>
                <RB.Button
                  variant="primary"
                  type="submit"
                  onClick={handleSubmitButton}
                >
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </div>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default CreateInvoice;
